;(() => {
  document.addEventListener('DOMContentLoaded', () => {
    const splides = document.querySelectorAll('.announcement-bar .splide')

    splides.forEach((splide) =>
      new Splide(splide, {
        type: 'loop',
        autoplay: true,
        perPage: 1,
        arrows: false,
        pagination: false,
      }).mount()
    )
  })
})()
